module.exports = __webpack_public_path__ + "img/785-ee4126.png";